import CenteredBannerNoImage
    from "../../components/legal-information-page-components/centered-banner-no-image/CenteredBannerNoImage.tsx";
import PricingTable from "../../components/pricing-page-components/pricing-table/PricingTable.tsx";
import PricingTableCalculateButton
    from "../../components/pricing-page-components/pricing-table/PricingTableCalculateButton.tsx";
import PricingFormSection from "../../components/pricing-page-components/pricing-form/PricingFormSection.tsx";
import PricingCalculator
    from "../../components/pricing-page-components/pricing-calculator/calculator/PricingCalculator.tsx";
import PricingServices from "../../components/pricing-page-components/pricing-services/PricingServices.tsx";
import GetStartedBanner from "../../components/home-page-components/get-started-banner/GetStartedBanner.tsx";
import {MessageSubjectEnum} from "../../enum/message/MessageSubjectEnum.ts";
import CustomHelmet from "../../components/helmet/CustomHelmet.tsx";
import Advantages from "../../components/building-online-page-components/advantages/Advantages.tsx";
import {PricingAdvantagesCardsConfig} from "../../configs/pricing-page/pricingAdvantagesCards.ts";
import {PricingFormInputsConfig} from "../../configs/pricing-page/pricingFormInputsConfig.ts";
import {PricingFormPageEnum} from "../../enum/pricing-form-page/pricingFormPageEnum.ts";
import {useState} from "react";

const PricingPage = () => {

    const [isCalculatorModalOpen, setIsCalculatorModalOpen] = useState<boolean>(false);

    return (
        <>
            <CustomHelmet title={'titles.pricing'} description={'pricing_banner_text'} />
            <CenteredBannerNoImage heading={'pricing'} paragraph={'pricing_banner_text'}/>
            <PricingTableCalculateButton setIsCalculatorModalOpen={setIsCalculatorModalOpen} />
            <PricingTable/>
            <PricingCalculator
                isCalculatorModalOpen={isCalculatorModalOpen}
                setIsCalculatorModalOpen={setIsCalculatorModalOpen}
            />
            <Advantages className={'opy-bg-gray pt-6'} heading={null} advantages={PricingAdvantagesCardsConfig} />
            <PricingFormSection heading={'fill_form_get_offer'}
                                description={'fast_secure_payments'}
                                subject={MessageSubjectEnum.SUBJECT_PRICING}
                                page={PricingFormPageEnum.PRICING_PAGE}
                                config={PricingFormInputsConfig} />
            <PricingServices />
            <GetStartedBanner bannerText={'boost_your_business'}
                              linkText={'get_started'}
                              linkClassname={'opy-button opy-button--white opy-button--medium text-center'}
                              linkTo={'routes.start_using_accept_payments'} />
        </>
    )
}

export default PricingPage;
